import { render, staticRenderFns } from "./CompanionNavBar.vue?vue&type=template&id=403069dc&lang=pug&"
import script from "./CompanionNavBar.vue?vue&type=script&lang=js&"
export * from "./CompanionNavBar.vue?vue&type=script&lang=js&"
import style0 from "./CompanionNavBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports